
import { CadastroForm, initializeCadastroForm } from './CadastroForm.js';
import { PropertyResults, PropertyResultsManager } from './PropertyResults.js';


export function KadasterPage() {
    return (async () => {
        // Render the CadastroForm and PropertyResults
        // advertenciasBox code removed
        return `
            <div id="header-container"></div>
            ${await CadastroForm({ formId: 'cadastro' })}
            <div class="flex justify-center w-full">
                <div class="container max-w-4xl mt-8 px-4">
                    ${PropertyResults()}
                    <div id="property-results-container"></div>
                </div>
            </div>
        `;
    })();
}

// Initialize the Kadaster page
export function initializeKadasterPage() {
    // Initialize the cadastro form functionality
    initializeCadastroForm();
    
    // Check for error data from PropertyResults redirect
    checkAndDisplayErrorData();
    
    // ✅ Extra attempt to restore form values after error redirect
    setTimeout(() => {
        if (window.cadastroAppInstance && window.cadastroAppInstance.restoreFormValues) {
            window.cadastroAppInstance.restoreFormValues();
        }
    }, 500);

    // Catastro map button and logic removed
}

// Check and display error data if available
function checkAndDisplayErrorData() {
    const errorDataString = sessionStorage.getItem('cadastroErrorData');
    if (!errorDataString) return;
    
    try {
        const errorData = JSON.parse(errorDataString);
        
        // Check if the data is not too old (max 5 minutes)
        const maxAge = 5 * 60 * 1000; // 5 minutes
        if (Date.now() - errorData.timestamp > maxAge) {
            sessionStorage.removeItem('cadastroErrorData');
            return;
        }
        
        // Initialize PropertyResults manager and display the data
        const propertyResultsManager = new PropertyResultsManager('property-results-container');
        
        // Wait a moment until the elements are loaded
        setTimeout(() => {
            propertyResultsManager.displayResults(
                errorData.result, 
                errorData.propertyData, 
                `${errorData.searchType} (redirected due to error 43)`,
                false  // No collapsible menu, show everything directly
            );
            
            // Scroll to the results
            const resultsContainer = document.getElementById('property-results-container');
            if (resultsContainer) {
                resultsContainer.scrollIntoView({ behavior: 'smooth', block: 'start' });
            }
        }, 100);
        
        // Remove the error data from sessionStorage after use
        sessionStorage.removeItem('cadastroErrorData');
        
    } catch (error) {
        // Error parsing cadastro error data
        sessionStorage.removeItem('cadastroErrorData');
    }
}

async function fetchParcelInfo(lat, lng, map) {
    try {
        const url = `https://www1.sedecatastro.gob.es/OVCWS/OVCService.svc/Consulta_Coordenadas`;
        const body = {
            Coordenadas: {
                x: lng,
                y: lat,
                SRS: "EPSG:4326"
            }
        };

        const response = await fetch(url, {
            method: "POST",
            body: JSON.stringify(body),
            headers: {
                "Content-Type": "application/json"
            }
        });

        const data = await response.json();

        if (!data || !data.Consulta_CoordenadasResult) {
            return;
        }

        const parcela = data.Consulta_CoordenadasResult.parcela;

        if (!parcela) {
            L.popup()
                .setLatLng([lat, lng])
                .setContent("No parcel found at this location.")
                .openOn(map);
            return;
        }

        const info = `
            <b>Parcel found</b><br>
            Province: ${parcela.Provincia}<br>
            Municipality: ${parcela.Municipio}<br>
            Cadastral Ref.: ${parcela.Ref_Catastral}
        `;

        L.popup()
            .setLatLng([lat, lng])
            .setContent(info)
            .openOn(map);

    } catch (err) {
        // Error fetching parcel information
    }
}
// Initialiseer de Kadasterkaart
// initializeKadasterMap is verwijderd
